import script from "./WaterImageFall.vue?vue&type=script&setup=true&lang=js"
export * from "./WaterImageFall.vue?vue&type=script&setup=true&lang=js"

import "./WaterImageFall.vue?vue&type=style&index=0&id=8ff34352&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff34352"]])

export default __exports__